import * as React from "react";
import { Trans } from "react-i18next";
import i18next from "i18next";
import { Button, Tag, Dialog, H5, Classes, Callout, FormGroup, InputGroup, Spinner, Popover } from "@blueprintjs/core";
import InfiniteScroll from 'react-infinite-scroller';
import { w3cwebsocket as W3CWebSocket } from "websocket";

import { authenticatedGetFetch, authenticatedPutFetch, getBackendRoute } from "../../utils/AuthenticatedFetch";


function solveNotification(id, message) {
  authenticatedPutFetch('/notification', { id: id, message: message }, (response) => { });
}

class Notification extends React.Component {
  constructor() {
    super();
    this.state = {
      solving: false,
      message: ""
    }
  }

  render() {
    if (this.state.redirect !== undefined)
      return (window.location.replace(`/ow/view${this.state.redirect}`));

    if (this.props.data !== undefined && this.props.data.alert !== undefined) {
      if (this.props.data.closingDate !== null)
        return (
          <div>
            <Tag round="true" fill={true} icon="tick-circle" intent="success">
              <H5>{this.props.data.alert.lbl}</H5>
              <div><Trans>park</Trans> n°{this.props.data.park} <Trans>equipment</Trans> n°{this.props.data.equipment}</div>
              <div>{new Date(this.props.data.date).toLocaleString(i18next.language)}</div>
              <div><b><Trans>{"event" + this.props.data.event}</Trans></b></div>
              <div>
                {(this.props.data.closedBy === null || this.props.data.closedBy === undefined) ?
                  <Trans>detected as solved</Trans>
                  :
                  <span><Trans>solved by</Trans> <i>{this.props.data.closedBy.login}</i></span>
                }
                <Trans>on</Trans> {new Date(this.props.data.closingDate).toLocaleString(i18next.language)}
              </div>
              {this.props.data.closingMessage !== null && this.props.data.closingMessage.length > 0 ? <div><Trans>with information:</Trans><i>{this.props.data.closingMessage}</i></div> : null}
            </Tag>
          </div>
        );
      else
        return (
          <div>
            <Tag round="true" icon="help" intent={this.props.data.alert.intent} onRemove={() => { this.setState({ solving: true }) }} fill={true}>
              <H5>{this.props.data.alert.lbl}</H5>
              <div><Trans>park</Trans> n°{this.props.data.park} <Trans>equipment</Trans> n°{this.props.data.equipment}</div>
              <div>{new Date(this.props.data.date).toLocaleString(i18next.language)}</div>
              <div><b><Trans>{"event" + this.props.data.event}</Trans></b></div>
            </Tag>
            <Dialog
              hasBackdrop={false}
              style={{ transition: 'none' }}
              isOpen={this.state.solving}
              canEscapeKeyClose={true}
              canOutsideClickClose={true}
              autoFocus={true}
              className={Classes.OVERLAY_SCROLL_CONTAINER}
              onClose={() => { this.setState({ solving: !this.state.solving }); }}
            >
              <div className={Classes.DIALOG_BODY}>
                <Callout intent="primary"><Trans>this notification will be displayed as solved for all other users</Trans></Callout>
                <FormGroup
                  label={<Trans>solving message</Trans>}
                  labelFor="message"
                >
                  <InputGroup
                    type="text"
                    id="message"
                    value={this.state.message}
                    onChange={(ti) => { this.setState({ message: ti.target.value }); }}
                  />
                </FormGroup>
              </div>
              <div className={Classes.DIALOG_FOOTER}>
                <Button
                  icon='undo'
                  intent="danger"
                  onClick={() => { this.setState({ solving: false }) }}
                >
                  <Trans>cancel</Trans>
                </Button>
                <Button
                  icon='tick'
                  onClick={() => { solveNotification(this.props.data.id, this.state.message); this.setState({ solving: false }) }}
                >
                  <Trans>solve</Trans>
                </Button>
              </div>
            </Dialog>
          </div>
        );
    }
    else
      return null;
  }
}

export default class NotificationsPannel extends React.Component {
  constructor() {
    super();
    this.state = {
      notifications: {},
      hasMore: true,
      pointer: 0,
      loading: false,
      alertCnt: 0
    }
  }

  componentDidMount() {
    if (localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null) {
      this.setState({ loading: true });
      authenticatedGetFetch('/notification/unsolved',
        (response) => {
          this.setState({
            alertCnt: response
          });
        });
      authenticatedGetFetch('/notifications?limit=5',
        (response) => {
          this.setState({
            loading: false,
            notifications: Object.fromEntries(Object.entries(response).map(([key, val]) => [val["id"], val])),
            pointer: response.length,
            isOpen: undefined
          });
        });
    } else {
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    if (this.client !== undefined)
      this.client.close();
  }

  render() {
    if (this.state.redirect !== undefined)
      return (window.location.replace(`/ow/view${this.state.redirect}`));

    if (localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null) {
      const ret = [];
      for (const id of Object.keys(this.state.notifications).sort().reverse())
        ret.push(<Notification data={this.state.notifications[id]} key={"notif" + id} />);
      if (ret.length === 0)
        ret.push(<Callout key="nonotif"><Trans>no notification to display</Trans></Callout>);

      return (
        <div>
          <Popover
            minimal={true}
            position="bottom"
            interactionKind="click"
            autoFocus={true}
            isOpen={this.state.isOpen}
            onOpening={() => {
              this.client = new W3CWebSocket(getBackendRoute("WS") + "/notifications/flow", ["Bearer", localStorage.getItem('token')]);
              this.client.onmessage = (message) => {
                const tmp = this.state.notifications;
                try {
                  const data = JSON.parse(message.data);
                  if (tmp[data.id] !== undefined) { //update
                    tmp[data.id] = data;
                    this.setState({ notifications: tmp });
                  } else { // new notification
                    tmp[data.id] = data;
                    this.setState({ notifications: tmp, pointer: this.state.pointer + 1 });
                  }
                } catch (e) {
                  console.error("Error while parsing " + JSON.stringify(message));
                }
              };
            }}
            onClosing={() => this.client.close()}
            content={
              <div>
                <Button icon="th-derived"
                  onClick={
                    () => {
                      this.setState({ isOpen: false }, () =>
                        this.setState({ redirect: "/notifications" }))
                    }
                  }>
                  <Trans>display all alerts</Trans>
                </Button>
                <div style={{ width: "400px", height: "350px", overflowY: "auto", overflowWrap: "break-word" }}>
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={(page) => {
                      authenticatedGetFetch("/notifications?limit=5&offset=" + page * 5,
                        (response) => {
                          this.setState({
                            notifications: { ...Object.fromEntries(Object.entries(response).map(([key, val]) => [val["id"], val])), ...this.state.notifications },
                            loading: false,
                            hasMore: (response.length === 5),
                            pointer: this.state.pointer + response.length,
                          });
                        });
                    }}
                    hasMore={this.state.hasMore}
                    loader={<Spinner />}
                    useWindow={false}
                  >
                    {ret}
                  </InfiniteScroll>
                </div>
              </div>
            }
          >
            <Button icon="notifications" minimal={true} intent={this.state.notifications.length > 0 ? "warning" : null}>
              <Tag>{this.state.alertCnt}</Tag>
            </Button>
          </Popover>
        </div>
      );
    } else return null;
  }
}
